import { __assign } from './node_modules/tslib/tslib.es6.js';
import * as React from 'react';

var SvgStarHalfFilled = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 25, fill: "none", viewBox: "0 0 24 25" }, props),
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 1.5c-.7629 0-1.5258.3987-1.9101 1.1963L8.0748 6.8775a.118.118 0 0 1-.0917.0634l-4.639.6055c-1.7548.229-2.4873 2.3917-1.1793 3.6211l3.3935 3.1895a.101.101 0 0 1 .0317.0923l-.852 4.5554c-.33 1.7648 1.5439 3.0699 3.0895 2.2395l4.1124-2.21a.13.13 0 0 1 .0601-.015z", clipRule: "evenodd" }))); };

export { SvgStarHalfFilled as default };
//# sourceMappingURL=star-half-filled.js.map
